import { useState } from "react";
import Box from "@material-ui/core/Box";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";

const VietnamTable = ({ usersInfo, downloadFile, checkUser }) => {
  return (
    <TableContainer component={Paper}>
      <Table aria-label="collapsible table" className="group-info-table">
        <TableHead className="group-info-table-head">
          <TableRow>
            <TableCell />
            <TableCell>#</TableCell>
            <TableCell>שם מלא</TableCell>
            <TableCell>טלפון</TableCell>
            <TableCell>תאריך נחיתה</TableCell>
            <TableCell>שדה נחיתה</TableCell>
            <TableCell>תמונת דַרכּוֹן</TableCell>
            <TableCell>תמונה של הדַרכּוֹן</TableCell>
            <TableCell>הושלם</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {usersInfo.map((user, index) => (
            <Row key={user._id} userData={user} checkUser={checkUser} index={index} downloadFile={downloadFile} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const Row = ({ userData, index, downloadFile, checkUser }) => {
  const [open, setOpen] = useState(false);

  const renderFileLink = (fileName, label) => {
    if (!fileName) return "-";
    return (
      <p className="link" onClick={() => downloadFile(fileName)}>
        {label}
      </p>
    );
  };

  return (
    <>
      <TableRow>
        <TableCell>
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell>{index + 1}</TableCell>
        <TableCell>{userData.fullName}</TableCell>
        <TableCell>{userData.phone}</TableCell>
        <TableCell>{userData.arrivalDate}</TableCell>
        <TableCell>{userData.arrivalAirport}</TableCell>
        <TableCell>{renderFileLink(userData.pictureOfPersonFileName, "הורד תמונה")}</TableCell>
        <TableCell>{renderFileLink(userData.pictureOfPassportFileName, "הורד צילום דַרכּוֹן")}</TableCell>
        <TableCell>
          <div className="custom-checkbox" onClick={() => checkUser(userData._id, userData.checked, index)}>
            {userData.checked ? <div className="check">&#10004;</div> : ""}
          </div>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ padding: 0 }} colSpan={9}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Table size="small" aria-label="user details" width="100%" className="group-info-sub-table">
              <TableHead className="group-info-sub-table-head">
                <TableRow>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>כתובת מגורים</TableCell>
                  <TableCell>עבודה</TableCell>
                  <TableCell>שם מלון</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell> </TableCell>
                  <TableCell>{userData.address}</TableCell>
                  <TableCell>
                    <Box className="group-info-bold-grey">שם חברה:</Box>
                    <Box>{userData.companyName}</Box>
                    <Box className="group-info-bold-grey">כתובת:</Box>
                    <Box>{userData.workAddress}</Box>
                    <Box className="group-info-bold-grey">מקצוע:</Box>
                    <Box>{userData.profession}</Box>
                  </TableCell>
                  <TableCell>{userData.hotelName}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

export default VietnamTable;
